import { Box, CircularProgress } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import Autocomplete from 'shared/components/widgets/autocomplete';
import Input from 'shared/components/widgets/input';

import Button from 'shared/components/widgets/button';
import AutocompleteContainer from 'shared/components/widgets/autocomplete-container';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const SystemFilter = ({ getFilteredList, isLoading }) => {
  const location = useLocation()
  const isRefresh = location?.state?.refresh
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      schAdmSt: 'all',
      admSchGroup: 'sch_name',
      schKeyword: '',
    },
  });

  const adminStatusFilterData = [
    {
      label: '전체',
      value: 'all',
    },
    { label: '신청', value: '10' },
    { label: '심사중', value: '20' },
    { label: '반려', value: '30' },
    { label: '정상', value: '50' },
  ];

  const searchTargetFilterData = [
    { label: '관리자 성명', value: 'sch_name' },
    { label: '관리자 아이디', value: 'sch_id' },
    { label: '관리자 성명+아이디', value: 'sch_name_id' },
  ];

  useEffect(() => {
    if (isRefresh) {
      setValue('schAdmSt', 'all')
      setValue('admSchGroup', 'sch_name')
      setValue('schKeyword', '')
    }
  }, [isRefresh])

  const keyword = watch('schKeyword');

  const onSubmit = (data) => {
    const { schAdmSt, admSchGroup, schKeyword } = data;
    getFilteredList([
      { key: 'page', value: 1 },
      {
        key: 'schAdmSt',
        value: schAdmSt === 'all' ? '' : schAdmSt,
      },
      { key: 'admSchGroup', value: admSchGroup },
      { key: 'schKeyword', value: schKeyword },
    ]);
  };
  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      gap={3}
      marginBottom="40px"
    >
      {/* ADMIN STATUS */}
      <AutocompleteContainer>
        <Controller
          name="schAdmSt"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                title="관리자 상태"
                options={adminStatusFilterData}
                defaultValue={
                  adminStatusFilterData.find((el) => el.value === 'all') ?? {
                    label: '전체',
                    value: 'all',
                  }
                }
                value={field?.value ?? 'all'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('all');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>

      <AutocompleteContainer>
        <Controller
          name="admSchGroup"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="검색어 대상"
                options={searchTargetFilterData}
                defaultValue={
                  searchTargetFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? { label: '관리자 성명', value: 'sch_name' }
                }
                value={field?.value ?? 'sch_name'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('sch_name');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>

      <Box flex={1}>
        <Controller
          name="schKeyword"
          control={control}
          render={({ field }) => {
            return (
              <Input
                {...field}
                keyword={keyword}
                isSearch
                placeholder="검색어를 입력해 주세요."
                clearAction={() => field.onChange('')}
                value={field.value}
                showErrorMsg={false}
              />
            );
          }}
        />
      </Box>
      <Button
        disabled={isLoading}
        variant="outlined"
        type="submit">
        {isLoading
          ?
          <CircularProgress size={20} color='secondary' />
          : '검색하기'
        }
      </Button>
    </Box>
  );
};

export default SystemFilter;
